import { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";

import Btn from "../../../components/buttons/Btn";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import { notify } from "../../../utils/notify";
import { validNotNull } from "../../../utils/validations";

const ModalCadastroDescricao = ({
  open,
  setOpen,
  title,
  editItem,
  onStore,
  onUpdate,
  onSaved,
}) => {
  const [description, setDescription] = useState("");
  const [errorsSubmit, setErrorsSubmit] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setDescription(editItem?.label || editItem?.descricao || "");
      setErrorsSubmit({});
    }
  }, [open, editItem]);

  const handleClose = () => {
    setDescription("");
    setErrorsSubmit({});
    setOpen(false);
  };

  const handleSave = async () => {
    const validateSubmit = validNotNull([
      { key: "description", value: description },
    ]);

    setErrorsSubmit({ ...validateSubmit.errorsValidation });

    if (validateSubmit.error) {
      return notify(
        "Verifique se os campos foram preenchidos corretamente.",
        true,
        "warning"
      );
    }

    try {
      setLoading(true);
      const body = { descricao: description };
      const callback = editItem?.value
        ? await onUpdate(editItem.value, body)
        : await onStore(body);

      if (!callback?.success) {
        if(callback?.internalCode === 4001) {
          return notify(callback?.message);
        }
        return notify(`Erro ao salvar ${title.toLowerCase()}.`);
      }

      const savedData = callback?.data || callback;
      const savedItem = {
        value: savedData?.id || editItem?.value,
        label: savedData?.descricao || description,
        descricao: savedData?.descricao || description,
      };

      notify(
        `${title} ${editItem?.value ? "atualizado" : "cadastrado"} com sucesso.`,
        true,
        "success"
      );

      onSaved?.(savedItem);
      handleClose();
    } catch (error) {
      console.error(error);
      notify(`Erro ao salvar ${title.toLowerCase()}.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextFieldErp
              label="Descrição *"
              value={description}
              setValue={setDescription}
              size="small"
              maxLength={255}
              error={!!errorsSubmit?.description}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn label="Cancelar" bgcolor="darkred" onClick={handleClose} />
        <Btn
          label="Salvar"
          onClick={handleSave}
          disabled={loading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalCadastroDescricao;
